export default {
    set: state => {
        // const newState = {};
        // whiteList.forEach(key => {
        //     state.hasOwnProperty(key) && (newState[key] = state[key]);
        // });
        // localStorage.setItem('bitacorapp_ronda', JSON.stringify(newState));
        localStorage.setItem('bitacorapp_ronda', JSON.stringify(state));
    },
    get: () => {
        const stateData = localStorage.getItem('bitacorapp_ronda');
        return !!stateData? JSON.parse(stateData): null;
    }
}

const whiteList = [
    'user',
    'roundInProgress',
    'currentRound'
];